(() => {
  const selector = 'img[data-bela-lumera-deferred-image]';

  const hydrate = (image) => {
    if (!image || image.dataset.belaLumeraLoaded === 'true') return;

    const src = image.dataset.src;
    if (!src) return;

    image.dataset.belaLumeraLoaded = 'true';

    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    image.src = src;

    delete image.dataset.src;
    delete image.dataset.srcset;
    delete image.dataset.sizes;
  };

  const isDisplayable = (image) => {
    const style = window.getComputedStyle(image);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const initialize = (root = document) => {
    const images = [...root.querySelectorAll(selector)];
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrate);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || !isDisplayable(entry.target)) return;
          hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '640px 360px' }
    );

    images.forEach((image) => observer.observe(image));

    window.addEventListener(
      'resize',
      () => images.filter(isDisplayable).forEach(hydrate),
      { once: true, passive: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
